import {
  ADD_TO_WISHLIST,
  DELETE_FROM_WISHLIST,
  DELETE_ALL_FROM_WISHLIST,
  GET_WISHLIST_DATA
} from "../actions/wishlistActions";

const initState = [];

const wishlistReducer = (state = initState, action) => {
  const wishlistItems = state,
    product = action.payload;
  if (action.type === GET_WISHLIST_DATA) {
    return product
  }
  if (action.type === ADD_TO_WISHLIST) {
    const wishlistItem = wishlistItems.filter(
      item => item.id === product.id
    )[0];
    if (wishlistItem === undefined) {
      return [...wishlistItems, product];
    } else {
      return wishlistItems;
    }
  }

  if (action.type === DELETE_FROM_WISHLIST) {
    // Remove the item from wishlist
    return wishlistItems.filter(item => item.id !== product.id);
  }

  if (action.type === DELETE_ALL_FROM_WISHLIST) {
    return [];
  }

  return wishlistItems;
};

export default wishlistReducer;
